import { useSystemStatus } from '@/services/system-status';
import type { SystemStatusIndicator } from '@/services/system-status';
import { ResourceLink } from './resource-link';
import { Flex, Label } from '@customerio/pluma-components/react';
import { useAnalytics } from '@/services/analytics';

const STATUS_CONFIG: Record<
  SystemStatusIndicator | 'loading',
  { text: string; color: 'green' | 'yellow' | 'red' | 'grey' }
> = {
  none: { text: 'All good', color: 'green' },
  minor: { text: 'Minor issues', color: 'yellow' },
  major: { text: 'Major issues', color: 'red' },
  critical: { text: 'Critical issues', color: 'red' },
  loading: { text: 'Loading...', color: 'grey' },
};

export function SystemStatus() {
  const { indicator } = useSystemStatus();
  const { track } = useAnalytics();
  const config = STATUS_CONFIG[indicator ?? 'loading'];

  return (
    <ResourceLink
      title={
        <Flex w="full" justifyContent="space-between" alignItems="center" gap="050">
          <span>Customer.io status</span>
          <Label color={config.color}>{config.text}</Label>
        </Flex>
      }
      href="https://status.customerio.com/"
      isExternal
      onClick={() => {
        void track('help_center', 'systemStatusClicked', {});
      }}
    />
  );
}
